// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"736":"7ba5dd7c","951":"39cbf4d8"}[chunkId] + ".chunk.css";
};